import(/* webpackMode: "eager", webpackExports: ["MantineProvider"] */ "/vercel/path0/node_modules/@mantine/core/esm/core/MantineProvider/MantineProvider.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mantine/core/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lang]/layout.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ArtTheme/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientWrapper"] */ "/vercel/path0/src/components/ClientWrapper/ClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GenerateDictionariesModal"] */ "/vercel/path0/src/components/GenerateDictionnariesButton/GenerateDictionnariesButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/headerBurger/HeaderBurger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/dictionaries/dictionary-provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/global.scss");
;
import(/* webpackMode: "eager", webpackExports: ["theme"] */ "/vercel/path0/theme.ts");
